(ns quuppa.qsm.configuration.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx
  ::get-success
  (fn [_ [_ _qpe-identity _resp]]
    ;; Response contains the updated configuration value,
    ;; but we are now trusting the qpe value is broadcasted to all clients,
    ;; including this client, to show the new value.
    {:fx [[:dispatch [:notifications/notify
                      {:type       :success
                       :heading    "QPE configuration updated"
                       :timeout-ms 5000}]]]}))

(rf/reg-event-fx
  ::error
  (fn [_ [_ _qpe-identity error]]
    (js/console.log error)
    {:fx [[:dispatch [:notifications/notify
                      {:type       :error
                       :heading    "Action failed!"
                       :message    (:err-msg error)}]]]}))

(rf/reg-event-fx
  ::set-values
  (fn [_ [_ qpe-identity new-vals]]
    {:fx [[:server-dispatch {:event      [:qpe/set-configuration (assoc new-vals :qpe-identity qpe-identity)]
                             :on-success [::get-success qpe-identity]
                             :on-error   [::error qpe-identity]}]]}))
